<template>
  <div>
    <el-row>
      <div style="display:flex;justify-content:space-between;">
        <div>
          <div style="display:flex;">
              <div style="font-size:16px;">公仔名称：<b>{{chooseItem.crafite_name}}</b></div>
              <div style="font-size:16px;margin-left:80px;">数量：<b>{{chooseItem.counts}}</b></div>
          </div>
          <div style="display:flex;">
              <div style="font-size:16px;">开始时间：<b>{{chooseItem.start_time}}</b></div>
              <div style="font-size:16px;margin-left:50px;">结束时间：<b>{{chooseItem.end_time}}</b></div>
          </div>
        </div>
        <el-button type="primary" style="height:45px;margin-right:80px;" size="small" @click="exportCsv()">导出</el-button>
      </div>
        <div style="display:flex;justify-content:flex-end;margin-bottom:20px;margin-top:15px;">
            <el-button type="primary" @click="order_by()" :icon="chooseItem.order_by?'el-icon-caret-bottom':'el-icon-caret-top'" style="margin-right:20px;">时间{{chooseItem.order_by?'降序':'升序'}}排序</el-button>
            <el-select v-model="chooseItem.group_by" filterable placeholder="筛选方式" @change="getData()">
                <el-option v-for="item in group_by_list" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
        </div>
    </el-row>
    <el-row>
      <el-table border stripe :data="data_list" :height="450" empty-text="Temporarily no data">
        <el-table-column label="No" type="index"></el-table-column>
        <el-table-column align="center" label="公仔名称" prop="crafite_name" ></el-table-column>
        <el-table-column align="center" label="公仔id" prop="craftie_no">
            <template slot-scope="scope">
                <a @click="copy(scope.row.craftie_no)" style="color:#409EFF;">{{scope.row.craftie_no}}</a>
            </template>
        </el-table-column>
        <el-table-column align="center" label="数量" prop="counts" min-width="50px"></el-table-column>
        <el-table-column align="center" label="开始时间" prop="">
          <template slot-scope="scope">
            <p>{{scope.row.create_time}}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="结束时间" prop="">
          <template slot-scope="scope">
            <p>{{scope.row.create_time}}</p>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row align="right">
      <el-col align="right">
      <el-button size="small" @click="$emit('close')">back</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import json2csv from "json2csv"
  export default {
    name: 'DeviceCrafite',
    props: {
      chooseItem: Object,
      close: Function
    },
    data () {
      return {
        group_by_list:[
            { label: "按年", value: 'y' },
            { label: "按月", value: 'm' },
            { label: "按日", value: 'd' },
            { label: "按时", value: 'h' }
        ],
        data_list: []
      }
    },
    created () {
      this.getData()
    },
    methods: {

        getData () {
            let loading = this.$util.loading()
            this.$api.rootV1.post(
              '/web/craftiesearch/search/itemlist',
              this.chooseItem,
              (res) => {
                if (res.errcode === 0) {
                  this.data_list = res.data
                }
                loading.close()
              },
              () => { loading.close() }
            )
        },

        order_by () {
            if(this.chooseItem.order_by){
                this.chooseItem.order_by = 0
            }else{
                this.chooseItem.order_by = 1
            }
            this.getData();
        },

        copy(data){
            let url = data;
            let oInput = document.createElement('input');
            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.$message({
                message: '复制成功',
                type: 'success'
            });
            oInput.remove()
        },

        exportCsv(){
            try{
                const res = json2csv.parse(this.data_list,{excelStrings: true})
                if(this.isIE()){
                    let BOM ="\uFEFF";
                    var csvData = new Blob([BOM + res],{type: "text/csv"});
                    navigator.msSaveBlob(csvData,'search.csv');
                }else{
                    let csvContent = "data:type/csv;charset=utf-8,\uFEFF"+ res;
                    this.createDownLoadClick(csvContent,'search.csv');
                }
            }catch(err){
                console.log("out=== error",err);
            }
        },

        isIE(){
            let isIE = false;
            if(navigator.userAgent.indexOf("compatible") > -1 && navigator.userAgent.indexOf("MSIE") > -1){
                isIE = true
            }
            if(navigator.userAgent.indexOf("Trident") > -1){
                isIE = true
            }
            return isIE;
        },

        createDownLoadClick(content,fileName){
            const link = document.createElement("a");
            link.href = encodeURI(content);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/craftieSearch/CraftieItemSearch.vue